import styled from 'styled-components';
import { Avatar } from 'antd';

export default styled(Avatar)`
  margin-right: 0.5rem;
  font-size: 1.5rem;
  background: transparent;
  color: ${({ theme }) => theme.neutralVariants[0]};
`;
